import { storage } from 'helpers';
import PropTypes from 'prop-types';

const CheckAuth = ({ children, authorityCode }) => {
  const currentUser = storage.getUserInfo();
  const userAuthorities = currentUser?.role?.authorities;
  const index = userAuthorities?.findIndex((auth) => auth.code === authorityCode);
  if (index !== -1) {
    return children;
  }

  return null;
};

CheckAuth.propTypes = {
  children: PropTypes.node.isRequired,
  authorityCode: PropTypes.string.isRequired,
};

export default CheckAuth;
